<div [innerHTML]="renderedHtml" class="markdown-content"></div>
